(function () {
  function init(main, DTS) {
    var bar = main.querySelector('[data-dts-bar]'), stage = main.querySelector('[data-dts-stage]'), end = main.querySelector('#dts-dawn .dts-btn') || main.lastElementChild;
    if (!bar) return; bar.hidden = false;
    /* The bar must never stack on top of a chapter's own buy button, and must not sell the pillow while the visitor is reading the Airway120 chapter. */
    var airway = main.querySelector('#dts-airway');
    var ownBtns = [].slice.call(main.querySelectorAll('#dts-mp .dts-btn, #dts-airway .dts-btn'));
    var ticking = false;
    function inView(el, vh) { var r = el.getBoundingClientRect(); return r.bottom > 0 && r.top < vh - 40; }
    function covers(el, vh) { if (!el) return false; var r = el.getBoundingClientRect(); var vis = Math.min(r.bottom, vh) - Math.max(r.top, 0); return vis > vh * 0.5; }
    function frame() {
      ticking = false;
      var vh = window.innerHeight, past = stage ? stage.getBoundingClientRect().bottom < vh * 0.35 : window.pageYOffset > vh * 1.5;
      var er = end && end.getBoundingClientRect(), atEnd = er && er.top < vh - 40, gone = main.getBoundingClientRect().bottom < vh * 0.6;
      var clash = false;
      for (var i = 0; i < ownBtns.length && !clash; i++) clash = inView(ownBtns[i], vh);
      var on = !!(past && !atEnd && !gone && !clash && !covers(airway, vh));
      if (on !== bar.classList.contains('is-on')) { bar.classList.toggle('is-on', on); main.style.setProperty('--dts-bar-h', on && getComputedStyle(bar).display !== 'none' ? bar.offsetHeight + 'px' : '0px'); }
      bar.classList.toggle('has-chat', !!document.querySelector('#gorgias-chat-container iframe, #chat-button'));
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }, { passive: true });
    window.addEventListener('resize', function () { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }, { passive: true });
    frame();
  }
  if (window.DTS && window.DTS.register) window.DTS.register('bar', init);
  else document.addEventListener('DOMContentLoaded', function () { if (window.DTS && window.DTS.register) window.DTS.register('bar', init); });
})();
